var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-set" },
    [
      _vm._m(0),
      _vm.isAddSign
        ? _c(
            "h1",
            { staticClass: "com-title com-ht" },
            [
              _c(
                "el-button",
                {
                  staticClass: "return-a",
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.isAddSign = false
                    }
                  }
                },
                [_vm._v("返回")]
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "box" },
        [
          _vm.isAddSign
            ? _c(
                "el-row",
                { staticClass: "add-seal-box" },
                [
                  _c("el-col", { attrs: { span: 8, offset: 2 } }, [
                    _c("div", { staticClass: "priview-img" }, [
                      _c("img", { attrs: { src: _vm.previewSealUrl } })
                    ])
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 10, offset: 2 } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "sealForm",
                          attrs: {
                            model: _vm.sealParam,
                            rules: _vm.sealRules,
                            size: "small"
                          }
                        },
                        [
                          _c("el-form-item", [_vm._v("签章名称")]),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "chapterName" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "必填，1-50个字符" },
                                model: {
                                  value: _vm.sealParam.chapterName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.sealParam, "chapterName", $$v)
                                  },
                                  expression: "sealParam.chapterName"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-form-item", [
                            _c("b", [
                              _c("input", {
                                attrs: { type: "radio", checked: "" }
                              }),
                              _vm._v("签章样式")
                            ])
                          ]),
                          _c("el-form-item", [
                            _c("div", {
                              staticClass: "red-seal",
                              on: {
                                click: function($event) {
                                  _vm.sealParam.color = 0
                                }
                              }
                            }),
                            _c("div", {
                              staticClass: "blue-seal",
                              on: {
                                click: function($event) {
                                  _vm.sealParam.color = 1
                                }
                              }
                            })
                          ]),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "seal-dome",
                                          _vm.sealParam.path === 0 &&
                                          _vm.sealParam.fontType === 0
                                            ? "active"
                                            : ""
                                        ],
                                        on: {
                                          click: function($event) {
                                            _vm.sealParam.path = 0
                                            _vm.sealParam.fontType = 0
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: "/images/chap_demo_1.jpg",
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ]),
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "seal-dome",
                                          _vm.sealParam.path === "" &&
                                          _vm.sealParam.fontType === 0
                                            ? "active"
                                            : ""
                                        ],
                                        on: {
                                          click: function($event) {
                                            _vm.sealParam.fontType = 0
                                            _vm.sealParam.path = ""
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: "/images/chap_demo_2.jpg",
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ]),
                                  _c("el-col", { attrs: { span: 8 } }, [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "seal-dome",
                                          _vm.sealParam.path === 1 &&
                                          _vm.sealParam.fontType === 0
                                            ? "active"
                                            : ""
                                        ],
                                        on: {
                                          click: function($event) {
                                            _vm.sealParam.fontType = 0
                                            _vm.sealParam.path = 1
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: "/images/chap_demo_3.jpg",
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                { on: { click: _vm.createSeal } },
                                [_vm._v("立即生成")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.isAddSign
            ? _c(
                "div",
                { staticClass: "box-wrap" },
                [
                  _c("div", [
                    _vm.ManualSignatureList &&
                    _vm.ManualSignatureList.handSignUrl
                      ? _c("div", { staticClass: "temone" }, [
                          _c("div", { staticClass: "t-box" }, [
                            1
                              ? _c("img", {
                                  staticClass: "mr-label",
                                  attrs: { src: "/images/web/icon-default.png" }
                                })
                              : _vm._e(),
                            _c("img", {
                              staticClass: "y-img",
                              attrs: {
                                src: _vm.ManualSignatureList.imgSrc,
                                title: ""
                              }
                            }),
                            _c("div", { staticClass: "msk" }, [
                              _c("span", {
                                staticClass: "el-icon-edit-outline",
                                staticStyle: { "margin-top": "1px" },
                                attrs: { title: "修改" },
                                on: { click: _vm.handWritingChapterEdit }
                              })
                            ])
                          ]),
                          _c("p", { attrs: { title: "手写章" } }, [
                            _vm._v("手写章")
                          ])
                        ])
                      : _c(
                          "div",
                          {
                            staticClass: "temone add",
                            on: { click: _vm.handWritingChapterEdit }
                          },
                          [_c("span", { staticClass: "el-icon-plus" })]
                        )
                  ]),
                  _vm.defalutChapter
                    ? _c("div", { staticClass: "temone" }, [
                        _c("div", { staticClass: "t-box" }, [
                          _c("img", {
                            staticClass: "y-img",
                            attrs: {
                              src:
                                "data:image/jpeg;base64," +
                                this.defalutChapter.signName
                            }
                          })
                        ]),
                        _c("p", { attrs: { title: "系统图形章" } }, [
                          _vm._v("系统图形章")
                        ])
                      ])
                    : _vm._e(),
                  _vm._l(_vm.chapterList, function(item, index) {
                    return [
                      _vm.chapterList
                        ? _c("div", { key: index, staticClass: "temone" }, [
                            _c("div", { staticClass: "t-box" }, [
                              _c("img", {
                                staticClass: "y-img",
                                attrs: {
                                  src: item.signUrl,
                                  title: item.signName
                                }
                              }),
                              _c("div", { staticClass: "msk" }, [
                                _c("span", {
                                  staticClass: "el-icon-edit-outline",
                                  staticStyle: { "margin-top": "1px" },
                                  attrs: { title: "修改" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openFileUploadDialog(item)
                                    }
                                  }
                                }),
                                _c("span", {
                                  staticClass: "el-icon-delete",
                                  attrs: { title: "删除" },
                                  on: {
                                    click: function($event) {
                                      return _vm.delChapter(item.signId)
                                    }
                                  }
                                })
                              ])
                            ]),
                            _c(
                              "p",
                              {
                                attrs: {
                                  title:
                                    item.signName + "(ID:" + item.signId + ")"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      item.signName + "(ID:" + item.signId + ")"
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  }),
                  _c(
                    "el-popover",
                    { attrs: { placement: "right", width: "200" } },
                    [
                      _c(
                        "div",
                        { staticClass: "popover-style" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.gotoAuth(0)
                                }
                              }
                            },
                            [_vm._v("本地上传\n          ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.gotoAuth(1)
                                }
                              }
                            },
                            [_vm._v("在线制作")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "temone add",
                          attrs: { slot: "reference" },
                          slot: "reference"
                        },
                        [_c("span", { staticClass: "el-icon-plus" })]
                      )
                    ]
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm.authChapterArr.length
        ? _c(
            "div",
            { staticStyle: { "padding-bottom": "30px" } },
            _vm._l(_vm.authChapterArr, function(item, index) {
              return _c("div", { key: index }, [
                _c("h1", { staticClass: "com-title com-ht" }, [
                  _c("i"),
                  _vm._v("授权给我的-"),
                  _vm.userNameFn(item.corpUserId).userStemFrom === -16 &&
                  !_vm.isInDingTalk
                    ? _c("img", {
                        attrs: {
                          src: "/images/icon/dingIcon.png",
                          alt: "钉钉",
                          width: "20px"
                        }
                      })
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.userNameFn(item.corpUserId).corpName))
                ]),
                _c(
                  "div",
                  { staticClass: "box-wrap" },
                  [
                    item.list && item.list.length > 0
                      ? _vm._l(item.list, function(childItem, childIndex) {
                          return _c(
                            "div",
                            { key: childIndex, staticClass: "temone" },
                            [
                              _c("div", { staticClass: "t-box" }, [
                                _c("img", {
                                  staticClass: "y-img",
                                  attrs: {
                                    src: childItem.signUrl,
                                    title: childItem.sealName
                                  }
                                })
                              ]),
                              _c(
                                "p",
                                {
                                  attrs: {
                                    title:
                                      childItem.sealName +
                                      "(ID:" +
                                      childItem.corpSealId +
                                      ")"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        childItem.sealName +
                                          "(ID:" +
                                          childItem.corpSealId +
                                          ")"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              ),
                              (_vm.isInDingTalk
                              ? childItem.dingTalkFlow
                              : childItem.flowDetail)
                                ? _c(
                                    "div",
                                    { staticClass: "info_box" },
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "top-start",
                                            trigger: "click"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                padding: "10px",
                                                "font-weight": "bold"
                                              }
                                            },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.isInDingTalk
                                                        ? childItem.dingTalkFlow
                                                            .flowName
                                                        : childItem.flowDetail
                                                            .flowName
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    height: "125px",
                                                    "overflow-y": "scroll"
                                                  }
                                                },
                                                [
                                                  _c("approval-process", {
                                                    attrs: {
                                                      flowInfo: _vm.computeInfo(
                                                        _vm.isInDingTalk
                                                          ? childItem.dingTalkFlow
                                                          : childItem.flowDetail
                                                      ),
                                                      orderFlag: _vm.isInDingTalk
                                                        ? childItem.dingTalkFlow
                                                            .flowType
                                                        : childItem.flowDetail
                                                            .orderFlag
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "approve_info",
                                              attrs: { slot: "reference" },
                                              slot: "reference"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isInDingTalk
                                                    ? childItem.dingTalkFlow
                                                        .flowName
                                                    : childItem.flowDetail
                                                        .flowName
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        })
                      : !item.sealName
                      ? _c("no-data", {
                          attrs: {
                            slot: "empty",
                            text: "企业暂未授权印章给您，如需使用请联系管理员"
                          },
                          slot: "empty"
                        })
                      : _vm._e()
                  ],
                  2
                )
              ])
            }),
            0
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改签章",
            visible: _vm.isUpdateSeal,
            width: "550px"
          },
          on: {
            "update:visible": function($event) {
              _vm.isUpdateSeal = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              key: _vm.updateInfo.signId,
              ref: "updateSeal",
              staticClass: "update-seal",
              attrs: {
                model: _vm.updateInfo,
                rules: _vm.sealRules,
                size: "small"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "seal-show" }, [
                      _c("img", { attrs: { src: _vm.updateInfo.sealUrl } })
                    ])
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "chapterName" } },
                        [
                          _c("p", [_vm._v("签章名字")]),
                          _c("el-input", {
                            attrs: { placeholder: "支持1-50个字符" },
                            model: {
                              value: _vm.updateInfo.chapterName,
                              callback: function($$v) {
                                _vm.$set(_vm.updateInfo, "chapterName", $$v)
                              },
                              expression: "updateInfo.chapterName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "text-center footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "danger" },
                      on: { click: _vm.updateSeal }
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn btn-cancel",
                      on: {
                        click: function($event) {
                          _vm.isUpdateSeal = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "modifi-seal",
          attrs: { visible: _vm.visibleSealDialog, width: "340px" },
          on: {
            "update:visible": function($event) {
              _vm.visibleSealDialog = $event
            }
          }
        },
        [
          _vm.handWritingChapterInfo
            ? [
                _c("qrcode-vue", {
                  key: "seal",
                  attrs: {
                    value: _vm.handWritingChapterInfo.url,
                    size: 300,
                    leave: "H"
                  }
                }),
                _c(
                  "p",
                  {
                    staticClass: "text-center",
                    staticStyle: {
                      "font-size": "12px",
                      "margin-bottom": "15px"
                    }
                  },
                  [_vm._v("\n          请使用手机扫码设置签字！\n        ")]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.addUserLocalSignFn }
                  },
                  [_vm._v("图片上传")]
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c("goto-auth", {
        attrs: { authDialog: _vm.authDialog },
        on: {
          "update:authDialog": function($event) {
            _vm.authDialog = $event
          },
          "update:auth-dialog": function($event) {
            _vm.authDialog = $event
          }
        }
      }),
      _vm.localAddSign
        ? _c("create-local-seal", {
            attrs: { userType: 0, newSign: _vm.newSign },
            on: { signCreated: _vm.signCreated }
          })
        : _vm._e(),
      _vm.userLocalAddSign
        ? _c("userLocalSeal", {
            attrs: { newSign: _vm.handWritingChapterInfo },
            on: { signCreated: _vm.signCreated }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "com-title com-ht" }, [
      _c("i"),
      _vm._v("个人签章")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e0f4776", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e0f4776","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/personSet.vue
// module id = IWNt
// module chunks = 75